export default __webpack_public_path__ + "static/media/ddbc.17671270.mp4";